import _ from 'lodash'
import {api} from '../api';
import {
    ORDER_LIST_FETCHED,
    ORDER_MODEL_UPDATED_BY_FORM,
    ORDER_STATUS_UPDATED,
    ORDER_LINE_UPDATED_BY_FORM,
    ORDER_MODEL_LOADED,
    ORDER_LINE_ADDED_TO_MODEL,
    ORDER_LINE_UPDATED_OF_UNSAVED_MODEL,
    ORDER_LINE_DELETED_OF_MODEL,
    UPDATE_ORDER_HOLD_REASON,
    ORDER_NOTE_ADDED,
    ORDER_NOTE_DELETE
} from './types'

export const fetchOrder = (jwt,params) => (dispatch) => {
    return api.order.fetch(jwt, params).then(res => {
        dispatch({
            type: ORDER_LIST_FETCHED,
            payload: res.data.data
        })
        return res;
    }).catch( err => {
        throw err
    })
}

export const loadOrderById = (jwt, id, type) => (dispatch) => {
    if (_.isInteger(parseInt(id))) {
        return api.order.loadModel(jwt, id).then( res => {
            dispatch({
                type: ORDER_MODEL_LOADED,
                payload: res.data.data
            })
            return res;
        }).catch( err => {
            throw err
        })
    } else {
        dispatch({
            type: ORDER_MODEL_LOADED,
            payload: {
                id: null,
                type: type,
                status: 'Open',
                relation_id: null,
                contact_id: null,
                warehouse_id: null,
                ship_to: '',
                bill_to: '',
                so: '',
                reference: '',
                po: '',
                issued_at: '',
                ship_at: '',
                currency: 'CAD',
                term_id: '',
                tax_id: '',
                assigned_to: '',
                notes: '',
                woo_id: null,
                relations: {

                },
                bill_address: {},
                ship_address: {},
                lines_view: [],
                shipments: []
            }
        })
    }
}

export const resetOrderModelInStore = () => {
    return ({
        type: ORDER_MODEL_LOADED,
        payload: {
            id: null,
            type: 'Customer Order',
            status: 'Open',
            relation_id: null,
            contact_id: null,
            warehouse_id: null,
            ship_to: '',
            bill_to: '',
            so: '',
            reference: '',
            po: '',
            issued_at: '',
            ship_at: '',
            currency: 'CAD',
            term_id: '',
            tax_id: '',
            assigned_to: '',
            notes: '',
            woo_id: null,
            relations: {

            },
            bill_address: {},
            ship_address: {},
            lines_view: [],
            shipments: []
        }
    })
}

export const updateOrderModelInStore = (field, value, isLine) => {
    if (isLine) {
        return ({
            type: ORDER_LINE_UPDATED_BY_FORM,
            payload: {field, value}
        });
    } else {
        return ({
            type: ORDER_MODEL_UPDATED_BY_FORM,
            payload: {field, value}
        });
    }
}


export const addLineToUnsavedModel = (inventory, orderType) => {
    const {special_pricings} = inventory;
    let price = 0;
    let sku = null;
    let name = null;
    if(orderType === "Customer Order" || orderType === "Customer Return") {
        price = inventory.selling;
    }
    if(orderType === "Vendor Order" || orderType === "Vendor Return") {
        price = inventory.cost;
    }
    if (_.isArray(special_pricings)) {
        if (special_pricings.length > 0) {
            price = special_pricings[0].pivot.special_price;
            sku  = special_pricings[0].pivot.special_sku;
            name  = special_pricings[0].pivot.special_name;
        }
    }
    const line = {
        id: 'Unsaved'+_.uniqueId(),
        order_id: null,
        inventory_id: inventory.id,
        uom: 'Each',
        quantity: 1,
        price: price,
        special_sku: sku,
        special_name: name,
        processed: 0,
        inventory: inventory
    }
    return({
        type: ORDER_LINE_ADDED_TO_MODEL,
        payload: line
    });
}

export const updateLineOfModel = (lineId, field, value) => {
    //Do not save on server
    return ({
        type: ORDER_LINE_UPDATED_OF_UNSAVED_MODEL,
        payload: {
            lineId,field,value
        }
    });
}

export const deleteLineOfUnsavedModel = (lineId) => {
    return ({
        type: ORDER_LINE_DELETED_OF_MODEL,
        payload: lineId
    });
}

export const addLineToSavedModel = (jwt, inventory, orderType, orderId) => (dispatch) =>{
    const {special_pricings} = inventory;
    let price = 0;
    let sku = null;
    let name = null;
    if(orderType === "Customer Order" || orderType === "Customer Return") {
        price = inventory.selling;
    }
    if(orderType === "Vendor Order" || orderType === "Vendor Return") {
        price = inventory.cost;
    }
    if (_.isArray(special_pricings)) {
        if (special_pricings.length > 0) {
            price = special_pricings[0].pivot.special_price;
            sku  = special_pricings[0].pivot.special_sku;
            name  = special_pricings[0].pivot.special_name;
        }
    }
    const line = {
        inventory_id: inventory.id,
        uom: 'Each',
        quantity: 1,
        price: price,
        special_sku: sku,
        special_name: name
    }

    return api.order.addLine(jwt, line, orderId).then( res => {
        const {data} = res.data;
        data.inventory = inventory;
        data.processed = 0;
        dispatch({
            type: ORDER_LINE_ADDED_TO_MODEL,
            payload: data
        })
        return res;
    }).catch(err => {throw err});


}

export const deleteLineOfSavedModel = (jwt, line) => (dispatch) => {
    return api.order.deleteLine(jwt, line.order_id, line.id).then(res => {
        dispatch({
            type: ORDER_LINE_DELETED_OF_MODEL,
            payload: line.id
        })
        return res;
    }).catch(err => {throw err});
}

export const updateCompleteOrder = (jwt, model) => (dispatch) => {
    return api.order.update(jwt, model);
}

export const createFullOrder = (jwt, model) => (dispatch) => {
    return api.order.create(jwt, model).then(res => {
        dispatch({
            type: ORDER_MODEL_LOADED,
            payload: res.data.data
        });
        return res;
    }).catch( err => {throw err});
}

export const updateOrderStatus = (jwt, orderId, status) => (dispatch) => {
    return api.order.updateStatus(jwt, orderId, status).then(res => {
        dispatch({
            type: ORDER_STATUS_UPDATED,
            payload: status
        });
        return res;
    }).catch(err => {throw err});
}

export const holdOrder = (jwt, orderId, reason) => (dispatch) => {
    return api.order.putOnHold(jwt, orderId, reason).then(res => {
        dispatch({
            type: ORDER_STATUS_UPDATED,
            payload: 'Hold'
        });
        dispatch({
            type: UPDATE_ORDER_HOLD_REASON,
            payload: reason
        })
        return res;
    }).catch(err => {throw err});
}

export const cancelHold = (jwt, orderId) => (dispatch) => {
    return api.order.cancelOnHold(jwt, orderId).then(res => {
        dispatch({
            type: ORDER_STATUS_UPDATED,
            payload: 'Finalized'
        });
        return res;
    }).catch(err => {throw err});
}

export const createNote = (jwt, orderId, data) => (dispatch) => {
    return api.order.addNote(jwt, orderId, data).then(res => {
        dispatch({
            type: ORDER_NOTE_ADDED,
            payload: res.data.data
        });
        return res;
    })
}

export const deleteNote = (jwt, orderId, noteId, index) => (dispatch) => {
    return api.order.deleteNote(jwt, orderId, noteId).then(res => {
        dispatch({
            type: ORDER_NOTE_DELETE,
            payload: {
                index: index,
                data: res.data.data
            }
        });
        return res;
    })
}


// WEBPACK FOOTER //
// ./src/actions/order.js